import { Reveal } from "./Shared";

const MoqBand = () => (
  <section
    id="moq"
    data-testid="moq-info-banner"
    className="scroll-mt-24 py-20 sm:py-24"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="overflow-hidden rounded-[2.5rem] bg-peach border border-peach-deep/60">
        <div className="grid md:grid-cols-2">
          <div className="p-10 sm:p-14 md:border-r border-peach-deep/60">
            <p className="text-xs font-semibold uppercase tracking-[0.24em] text-coral">
              Customised pieces
            </p>
            <p className="mt-5 font-serif font-medium text-ink leading-none text-7xl sm:text-8xl">
              35<span className="text-coral text-4xl sm:text-5xl align-top ml-2">pcs</span>
            </p>
            <p className="mt-5 text-sm leading-relaxed text-cocoa max-w-xs">
              Minimum order for fully customised &amp; logo-branded gifts: your identity,
              printed, embossed or engraved.
            </p>
          </div>
          <div className="p-10 sm:p-14 border-t md:border-t-0 border-peach-deep/60 bg-cream/40">
            <p className="text-xs font-semibold uppercase tracking-[0.24em] text-sage-deep">
              Normal pieces
            </p>
            <p className="mt-5 font-serif font-medium text-ink leading-none text-7xl sm:text-8xl">
              Any<span className="text-sage text-4xl sm:text-5xl align-top ml-2">qty</span>
            </p>
            <p className="mt-5 text-sm leading-relaxed text-cocoa max-w-xs">
              No minimums on ready-made pieces: order one or a hundred, whatever the
              occasion calls for.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default MoqBand;
